import { CertificateCheckForm } from './_check-form'
import { CertificatePurchaseForm } from './_form-purchase'
import { getCartItems } from '../cart/_service'
import Modals from 'application/ui/modal/modal'

export function initCertificatesPageController() {
  initCertificateCheckForm()
  const purchaseForms = initCertificatePurchaseForms()
  initCertificateVariantTriggers(purchaseForms)

  const cartItems = getCartItems()
  const cartCountElement = document.querySelector(
    '[data-cart-count]'
  ) as HTMLElement
  if (cartCountElement) {
    cartCountElement.setAttribute(
      'data-cart-count',
      cartItems.length.toString()
    )
  }
}

export function initCertificateCheckForm() {
  const container = document.querySelector<HTMLElement>(
    '[data-form="certificate-check"]'
  )

  if (container) {
    new CertificateCheckForm(container)
  }
}

export function initCertificatePurchaseForms(): CertificatePurchaseForm[] {
  const container = document.querySelectorAll<HTMLElement>(
    '[data-form="certificate-purchase"]'
  )

  return Array.from(container).map(
    (element) => new CertificatePurchaseForm(element)
  )
}

export function initCertificateVariantTriggers(
  forms: CertificatePurchaseForm[]
) {
  document.addEventListener('click', (event) => {
    const trigger = (event.target as HTMLElement).closest<HTMLElement>(
      '[data-form-trigger]'
    )
    if (!trigger) return

    const modalName = trigger.dataset.formTrigger
    const price = Number(trigger.dataset.price)
    if (!modalName || !price) return

    forms.find((form) => form.modalName === modalName)?.setPrice(price)
    Modals.getInstance().openModal(modalName)
  })
}
